import React, { useState } from 'react'
import { getLocationsApi, newLocationApi, editLocationApi, deleteLocationApi } from '../api/locations'
import { useAuth } from './';
//Obtener Token


export function useLocations() {

const [loading, setLoading] = useState(true);
const [error, setError] = useState(false);
const [location, setLocation] = useState(null);

const {auth} = useAuth();


const getLocations = async () =>{
    try {
        setLoading(true);
        const response = await getLocationsApi();
        setLoading(false);
        setLocation(response);
    } catch (error) {
        setLoading(false);
        console.error(error)
    }
}


const newLocation = async(data) =>{
  
  try {
    setLoading(true)
    await newLocationApi(data, auth.token);
    setLoading(false);
   
  } catch (error) {
    setLoading(false)
    setError(error)
  }
}


const editLocation = async(id, data) =>{
  try {
    setLoading(true);
    await editLocationApi(id, data, auth.token);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    setError(error);
  }
}

const deleteLocation = async(id) =>{
    try {
      setLoading(true);
      await deleteLocationApi(id, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }


  return{
    loading,
    error,
    location,
    getLocations,
    newLocation,
    editLocation,
    deleteLocation

  }




}
